<template>
  <vs-prompt
    class="operation-report-delete-dialog"
    :title="title"
    :type="type"
    :color="color"
    :accept-text="acceptText"
    :cancel-text="cancelText"
    :active="active"
    @accept="onAccept"
    @cancel="onCancel"
  >
    <div>
      {{ confirmText }}
    </div>
  </vs-prompt>
</template>

<script>
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

const EVENTS = {
  ACCEPT: "accept",
  CANCEL: "cancel",
};

export default {
  name: "OperationReportDeleteDialog",
  props: {
    title: {
      type: String,
      default() {
        return this.$t("Views.Operation.Delete.Dialog.title");
      },
    },
    type: {
      type: String,
      default: "confirm",
    },
    color: {
      type: String,
      default: AISEA_COLOR.BLUE,
    },
    acceptText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Delete.Dialog.acceptText");
      },
    },
    cancelText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Delete.Dialog.cancelText");
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Delete.Dialog.confirmText");
      },
    },
  },
  methods: {
    onAccept() {
      this.$emit(EVENTS.ACCEPT);
    },
    onCancel() {
      this.$emit(EVENTS.CANCEL);
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-delete-dialog {
  ::v-deep .vs-dialog {
    width: 270px;
    .vs-dialog-cancel-button {
      background: #f8f8f8 !important;
      .vs-button-backgroundx.vs-button--background {
        display: none;
      }
    }
  }
}
